import { z } from 'zod';

// The guard's outcome vocabulary lives apart from the guard itself so the
// barrel (and every client bundle) can name an outcome without pulling in the
// denylist the guard runs.

/**
 * Row-level outcome, worst wins: a held message outranks a substituted push,
 * which outranks a shortened one. Closed so it can be a metric tag and a
 * `text` + CHECK column.
 */
export const GUARD_OUTCOME = ['pass', 'shortened', 'push_fallback', 'held'] as const;
export const guardOutcomeSchema = z.enum(GUARD_OUTCOME);
export type GuardOutcome = z.infer<typeof guardOutcomeSchema>;

export const PUSH_GUARD_OUTCOME = ['pass', 'shortened', 'fallback'] as const;
export type PushGuardOutcome = (typeof PUSH_GUARD_OUTCOME)[number];
export const MESSAGE_GUARD_OUTCOME = ['pass', 'held'] as const;
export type MessageGuardOutcome = (typeof MESSAGE_GUARD_OUTCOME)[number];

/**
 * Which screen a generated text failed, in the fixed order a caller reports
 * it: a clinical label first (the lockscreen screen includes the labels, but a
 * label is reported as itself), then a lockscreen substance term, a contact
 * detail, and a role-based title for Sona. Closed so it can be a metric tag.
 */
export const COPY_GUARD_RULE = [
  'clinical_label',
  'lockscreen_term',
  'contact_detail',
  'sona_title',
] as const;
export type CopyGuardRule = (typeof COPY_GUARD_RULE)[number];
